import { INSTALLATIONS } from "@/data/site";

export default function InstallationTypes() {
  return (
    <section
      id="installations"
      data-testid="installations-section"
      className="section-pad relative"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#FFC857] mb-6">
              — Installations
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.1] max-w-2xl">
              160+ rooftops, three{" "}
              <span className="italic text-[#FFC857]">distinct domains.</span>
            </h2>
          </div>
          <p className="text-[#A0ABC0] max-w-md font-light">
            We design at scale — from a single villa to a multi-acre factory —
            with the same obsession for engineering detail.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {INSTALLATIONS.map((inst, i) => (
            <div
              data-testid={`install-card-${i}`}
              key={inst.type}
              className="group relative overflow-hidden rounded-sm border border-white/10 aspect-[3/4]"
            >
              <img
                src={inst.image}
                alt={inst.type}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-[#050B14]/60 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-8">
                <div className="font-serif text-6xl text-[#FFC857] font-light leading-none">
                  {inst.count}
                </div>
                <div className="font-serif text-2xl text-white mt-3">
                  {inst.type}
                </div>
                <p className="mt-3 text-sm text-[#A0ABC0] font-light leading-relaxed">
                  {inst.blurb}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
